// src/utils/api.js

import { COLLECT_FEEDBACK_API } from "../config"

export const sendFeedback = async (type, message_id) => {
  try {
    const response = await fetch(COLLECT_FEEDBACK_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        type: type,
        message_id: message_id,}),
    });

    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error sending feedback:', error);
    throw error;
  }
};